import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { Subscription } from 'rxjs';
import { DataService, ISupplier } from '../../shared/data.service';
import { AuthService } from '../../shared/auth.service';
import { menuItems } from 'src/app/models/menu.model';
@Component({
  selector: 'pcc-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit, OnDestroy {
  private _subscriptions: Subscription[] = [];
  menuItems: MenuItem[];
  winningsUser = this.authService.isWinnings;
  supplier: ISupplier | undefined;

  constructor(
    private authService: AuthService,
    private dataService: DataService
  ) { }

  ngOnInit(): void {
    this.menuItems = menuItems;
    if (this.authService.supplier) {
      this.supplier = this.authService.supplier;
    } else {
      this._subscriptions.push(this.dataService.supplier$.subscribe(supplier => this.supplier = supplier));
    }
  }

  ngOnDestroy() {
    this._subscriptions.forEach(sub => sub.unsubscribe());
  }
}
